import React from "react";
import { formatYYYY_MM_DD } from "../../../utils/dateFormating";
import { currencyFormatter } from "../../../utils/formatting";

const OfferDetailsCard = ({ details, showServiceProName }) => {
  return (
    <div className="rounded-[0.625rem] px-4 sm:px-9 pt-3 pb-6 border border-light-blue">
      <h3 className="font-nonito_sans font-semibold text-[1.25rem] leading-[2.97rem] text-primary">
        Offer Details
      </h3>
      <hr className="h-[0.0625rem] bg-light-blue mb-[0.625rem]" />
      <div>
        <p className="font-inter font-normal text-sm text-content">
          {details?.description}
        </p>
        {/* Task Details */}
        <div className="mt-6">
          {/* Mobile layout */}
          <div className="flex flex-col gap-2 sm:hidden">
            {showServiceProName && (
              <div className="flex justify-between items-center">
                <span className="text-[#0F161E] text-sm font-medium font-inter">
                  Service Pro Name
                </span>
                <span className="text-[#4A4A4A] text-sm font-inter">
                  {`${details?.tasker?.firstName} ${details?.tasker?.lastName}`}
                </span>
              </div>
            )}
            <div className="flex justify-between items-center">
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Offer Date
              </span>
              <span className="text-[#4A4A4A] text-sm font-inter">
                {formatYYYY_MM_DD(details?.createdAt)}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Service Price
              </span>
              <span className="text-[#4A4A4A] text-sm font-inter">
                {currencyFormatter.format(details?.price)}
              </span>
            </div>
          </div>

          {/* Desktop layout */}
          <div className="hidden sm:flex gap-[2.125rem]">
            <div className="flex flex-col gap-1">
              {showServiceProName && (
                <span className="text-[#0F161E] text-sm font-medium font-inter">
                  Service Pro Name
                </span>
              )}
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Offer Date
              </span>
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Service Price
              </span>
            </div>
            <div className="flex flex-col gap-1">
              {showServiceProName && (
                <span className="text-[#4A4A4A] text-sm font-inter">
                  {`${details?.tasker?.firstName} ${details?.tasker?.lastName}`}
                </span>
              )}
              <span className="text-[#4A4A4A] text-sm font-inter">
                {formatYYYY_MM_DD(details?.createdAt)}
              </span>
              <span className="text-[#4A4A4A] text-sm font-inter">
                {currencyFormatter.format(details?.price)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferDetailsCard;
